<app-loader></app-loader>
@if(iconsLoaded){
  <router-outlet></router-outlet>
}
